<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <base-widget
    icon="lightning-charge-fill"
    :empty="isEmpty"
    :loading="isLoading"
    :title="$t('dashboard.quick_launch')"
  >
    <oxd-grid :cols="3" class="orangehrm-quick-launch">
      <oxd-grid-item
        v-for="action in sortedActions"
        :key="action"
        class="orangehrm-quick-launch-card"
      >
        <oxd-icon-button
          icon-type="svg"
          class="orangehrm-quick-launch-icon"
          :name="action.icon"
          :title="action.label"
          @click="onClickAction(action.path, action)"
        />
        <div class="orangehrm-quick-launch-heading" :title="action.label">
          <oxd-text tag="p" class="--text">
            {{ action.label }}
          </oxd-text>
        </div>
      </oxd-grid-item>
    </oxd-grid>
  </base-widget>
</template>

<script>
import {navigate} from '@/core/util/helper/navigation';
import {APIService} from '@/core/util/services/api.service';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';

export default {
  name: 'QuickLaunchWidget',

  components: {
    'base-widget': BaseWidget,
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/dashboard/shortcuts',
    );

    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      quickLaunchActions: [],
      access_token: '',
      userID: '',
    };
  },

  computed: {
    isEmpty() {
      return this.quickLaunchActions.length === 0;
    },
    sortedActions() {
      return [...this.quickLaunchActions].sort(
        (prevItem, item) => prevItem.order - item.order,
      );
    },
  },

  beforeMount() {
    this.isLoading = true;

    const ACTIONS = {
      // 'leave.assign_leave': {
      //   order: 1,
      //   icon: 'leaveassign',
      //   label: this.$t('leave.assign_leave'),
      //   path: '/leave/assignLeave',
      // },
      // 'leave.leave_list': {
      //   order: 2,
      //   icon: 'leavelist',
      //   label: this.$t('leave.leave_list'),
      //   path: '/leave/viewLeaveList',
      // },
      'time.employee_timesheet': {
        order: 1,
        icon: 'timesheets',
        label: '更表',
        path: '/time/viewMyTimesheetLocation',
      },
      'leave.apply_leave': {
        order: 2,
        icon: 'leaveapply',
        label: '提交員工休假',
        // path: '/leave/applyLeave',
        path: '/leave/assignLeave',
      },
      // 'leave.my_leave': {
      //   order: 3,
      //   icon: 'myleaves',
      //   label: this.$t('general.my_leave'),
      //   path: '/leave/viewMyLeaveList',
      // },
      // 'time.my_timesheet': {
      //   order: 6,
      //   icon: 'mytimesheet',
      //   label: this.$t('time.my_timesheet'),
      //   path: '/time/viewMyTimesheet',
      // },
      'pim.add_employee': {
        order: 4,
        icon: 'leaveassign',
        label: '添加員工',
        path: '/pim/addEmployee',
      },
      'admin.export_location': {
        order: 5,
        icon: 'leaveassign',
        label: '匯出打卡相片',
        path: '/admin/exportLocations',
      },
      'admin.list_attendance': {
        order: 6,
        icon: 'mytimesheet',
        label: '更表打卡記錄',
        path: '/attendance/listAttendanceRecord',
      },
      'admin.submit_claim': {
        order: 7,
        icon: 'mytimesheet',
        label: '申報開銷',
        path: '/claim/submitClaim',
      },
      'admin.view_claim': {
        order: 8,
        icon: 'mytimesheet',
        label: '員工開銷',
        path: '/claim/viewAssignClaim',
      },
      'admin.manage_location': {
        order: 9,
        icon: 'leaveassign',
        label: '管理店舖',
        path: '/admin/viewLocations',
      },
      'admin.attendance': {
        order: 10,
        icon: 'mytimesheet',
        label: '打卡',
        path: '/attendance/punchIn',
      },
      'admin.app_launch': {
        order: 11,
        icon: 'mytimesheet',
        label: 'APP捷徑',
        path: '/../api/app_launch.php',
      },
      'admin.attendance_report': {
        order: 12,
        icon: 'mytimesheet',
        label: '匯出糧單',
        path: '/attendance/attendanceReport',
      },
    };

    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;
        ACTIONS['admin.app_launch'].path +=
          '?userID=' + data.userID + '&access_token=' + data.access_token;
        for (const key in data) {
          if (data[key] && ACTIONS[key]) {
            ACTIONS[key].key = key;
            this.quickLaunchActions.push(ACTIONS[key]);
          }
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onClickAction(path, action) {
      console.log('onClickAction', action);
      if (action.key == 'admin.app_launch') {
        window.open(window.appGlobal.baseUrl + path, '_blank');
      } else if (path) navigate(path);
    },
  },
};
</script>

<style src="./quick-launch-widget.scss" lang="scss" scoped></style>
